jQuery(document).ready(function ($) {
    var $single_gallery = $('.single-gallery');

    if (!$single_gallery.length) return

    var single_gallery_thumbs = new Swiper(".single-gallery-thumbs .swiper-container", {
        spaceBetween: 5,
        slidesPerView: 3,
        centerInsufficientSlides: true,
        navigation: {
            nextEl: $('.single-gallery-thumbs .carousel-nav.next')[0],
            prevEl: $('.single-gallery-thumbs .carousel-nav.prev')[0],
        },
        breakpoints: {
            768: {
                slidesPerView: 4
            },

            992: {
                slidesPerView: 3
            },

            1200: {
                slidesPerView: 4
            }
        }
    });

    var single_gallery_primary = new Swiper(".single-gallery-primary .swiper-container", {
        allowTouchMove: false,
        // allowSlideNext: false,
        // allowSlidePrev: false,
        spaceBetween: 5,
        thumbs: {
            swiper: single_gallery_thumbs,
        },
    });
});